<template>
    <QuestionWrapper :isCardLayout="false" v-bind="{...$props, ...$attrs}">
        <template v-slot:question>
            <h1 class="mb-0">{{question.comments}}</h1>
        </template>
    </QuestionWrapper>
</template>

<script>
    import questionMixin from "@/components/pages/registration/questions/questionMixin";

    export default {
        name: "HeadingQuestion",
        mixins: [questionMixin],
    }
</script>

<style scoped>

</style>